/**
 * BonusInfo defines model for free bets data
 *
 * @typedef BonusInfo
 * @type {Object}
 * @property {name} String name of the Free bet
 * @property {bonusId} String id of free bet
 * @property {amount} number amount of free bet
 */

export class BonusInfo {
    name: string;
    bonusId: string;
    amount: number;
    title: string;
    isRiskFreeBet: boolean;

    constructor(source: BonusInfo) {
        this.name = source.name;
        this.bonusId = source.bonusId;
        this.amount = source.amount;
        this.title = source.title;
        this.isRiskFreeBet = source.isRiskFreeBet;
    }
}